import { Link } from 'react-router-dom';
import LegalLayout from './LegalLayout';
import { OPERATOR } from './meta';

export default function Rights() {
  return (
    <LegalLayout title="権利侵害の申告（送信防止措置の申出）" enacted={OPERATOR.effectiveDate}>
      <p>
        {OPERATOR.serviceName}
        に投稿されたコンテンツにより、著作権・商標権・肖像権・プライバシー・名誉その他の権利が侵害されていると考える方は、以下の手順で運営者に申告できます。本ページは、特定電気通信による情報の流通によって発生する権利侵害等への対処に関する法律（情報流通プラットフォーム対処法。旧「プロバイダ責任制限法」）の趣旨に沿った、権利侵害情報の送信防止措置に関する申出の窓口です。
      </p>

      <h2>1. 申告窓口</h2>
      <ul>
        <li>受付窓口: {OPERATOR.serviceName} 権利侵害申告窓口</li>
        <li>
          連絡先: <Link to={OPERATOR.contactPath}>{OPERATOR.contactLabel}</Link>
        </li>
      </ul>

      <h2>2. 申告に記載していただく事項</h2>
      <p>次の事項を明記してご連絡ください。情報が不十分な場合、対応できないことがあります。</p>
      <ol>
        <li>申告者の氏名（名称）、連絡先（メールアドレス等）。</li>
        <li>
          対象となるコンテンツを特定できる情報（本サービス上の URL、タイトル、投稿者のアカウント名等）。
        </li>
        <li>侵害されたとする権利の種類（著作権、商標権、肖像権、プライバシー、名誉等）。</li>
        <li>
          申告者が当該権利を有すること、または権利者の代理人であることの根拠。
        </li>
        <li>権利が侵害されていると考える具体的な理由。</li>
      </ol>

      <h2>3. 運営者の対応</h2>
      <ol>
        <li>
          運営者は、申告を受け付けた後、内容を確認します。明白な権利侵害があると判断した場合、または法令・利用規約に基づき必要と判断した場合、対象コンテンツの非表示・削除等の送信防止措置を講じることがあります。
        </li>
        <li>
          権利侵害の有無が直ちに判断できない場合、運営者は、投稿者に対して当該申告の内容を照会し、送信防止措置を講じることに同意するかどうかを確認することがあります。投稿者が照会を受けた日から相当の期間内に反論しないときは、運営者は送信防止措置を講じることができます。
        </li>
        <li>
          運営者は、送信防止措置の実施・不実施およびその判断について、法令に定める場合を除き、責任を負いません。
        </li>
      </ol>

      <h2>4. 発信者情報の開示について</h2>
      <p>
        投稿者（発信者）の情報の開示を求める場合は、情報流通プラットフォーム対処法に定める発信者情報開示請求の手続によることになります。運営者は、法令および裁判所の命令等に基づき、必要な範囲で対応します。
      </p>

      <h2>5. 虚偽申告について</h2>
      <p>
        虚偽の申告や、権利者でない者による不当な削除要求は、投稿者や運営者に損害を生じさせる可能性があります。申告内容についての責任は申告者が負うものとします。
      </p>

      <p className="legal__meta">制定日: {OPERATOR.effectiveDate}</p>
    </LegalLayout>
  );
}
